<template>
  <div id="faq" class="header-padding bg-light-grey">
    <header class="page-header border-bottom ff ff-center horizontal-padding section-padding">
      <h1>FAQ</h1>
    </header>
    
    <div class="ff ff-align-center ff-valign-top ff-block-top ff-lg-nowrap horizontal-padding section-padding max-width">
      <aside id="faq-categories" class="ff-auto">
        
        <div class="category-selector ff-desktop-hide" v-on:click="selectorOpen = !selectorOpen">
          <icon :name="'icon-' + currentCategory.icon" color="cyan" /> 
          <span class="category-name">{{ currentCategory.name }}</span>
          <div class="category-selector-arrow"><icon name="ui-chevron-down" color="grey" size=18 /></div>
        </div>
        
        <ul class="category-list" :class="{open: selectorOpen}">
          <li class="category-list-item" :class="currentCategory.name === 'All Categories' ? 'category-active' : ''" :key="all">
            <router-link to="/faq">
              <icon name="icon-group" :color="currentCategory.name === 'All Categories' ? 'cyan' : 'grey'" /> 
              <span class="category-name">All Categories</span>
              <span class="category-item-count">{{ faqTotal }}</span>
            </router-link>
          </li>
          
          <li v-for="category in categories.data" class="category-list-item" :class="currentCategory.name === category.name ? 'category-active' : ''" :key="'list-' + category.slug">
            <router-link :to="'/faq/' + category.slug">
              <icon :name="'icon-' + category.icon" :color="currentCategory.name === category.name ? 'cyan' : 'grey'" /> 
              <span class="category-name">{{ category.name }}</span>
              <span class="category-item-count">{{ category.total_faq }}</span>
            </router-link>
          </li>
        </ul>
      </aside>
      
      <section id="articles" class="ff-fill">
        
        <transition-group name="fade-list" tag="div" class="article-group-container">
          <div v-for="category in categories.filtered" class="article-group" :key="'group-' + category.slug">
          
            <h2 class="cyan">{{ category.name }}</h2>
            
            <article v-for="article in articles.data[category.slug]" :class="$route.path === article.url ? 'open' : 'closed'" :key="'item-' + article.slug">
              <router-link :to="$route.path===article.url ? currentCategory.url : article.url" class="faq-article-title">
                <span>{{ article.name }}</span>
                <div class="accordion-arrow"><icon name="ui-chevron-down" color="white" size=18 /></div>
              </router-link>
              <transition name="accordion">
                <div v-if="$route.path===article.url" class="faq-article-content">
                  <div v-html="article.details" class="faq-article-padding"></div>
                </div>
              </transition>
            </article>
          
          </div>
        </transition-group>
        
      </section>
    </div>
  </div>
</template>

<script>

// @ is an alias to /src
export default {
  name: "Faq",
  props: [
    "categorySlug",
    "articleSlug"
  ],
  data() {
    return {
      articles: {
        data: [],
        loading: false
      },
      categories: {
        data: [],
        filtered: [],
        loading: false
      },
      current: {
        categoryURL: '/faq'
      },
      selectorOpen: false
    }
  },
  computed: {
    apiURL() {
      return this.$store.state.apiURL;
    },
    faqTotal() {
      var faqTotal = 0;
      
      if(this.categories.data) {
        for( var i = 0; i < this.categories.data.length; i++ ){
          faqTotal += parseInt(this.categories.data[i].total_faq);
        }
      }
      
      return faqTotal;
    },
    meta() {
      var meta = {
        title: "FAQ",
        url: "https://www.csbplab.com.au/faq",
        desc: "",
        image: ""
      }
      
      if(this.categorySlug && !this.articleSlug) {
        meta.url = "https://www.csbplab.com.au/faq/"+this.categorySlug;
      }
      
      if(this.categorySlug && this.articleSlug) {
        meta.url = "https://www.csbplab.com.au/faq/"+this.categorySlug+'/'+this.articleSlug;
      }
      
      if(this.currentCategory.name) {
        meta.title = "FAQ | "+this.currentCategory.name;
      }
      
      return meta;
    },
    currentCategory() {
      var currentCategory = {
        name: "All Categories",
        url: this.current.categoryURL,
        icon: 'group'
      };
      
      if(this.categories.data && this.current.categoryURL !== '/faq') {
        let currentCatData = this.categories.data.find(cat => cat.slug == currentCategory.url.replace('/faq/', ''));
        currentCategory.name = currentCatData.name;
        currentCategory.icon = currentCatData.icon;
      }
      
      return currentCategory;
    }
  },
  beforeMount() {
    
    // Check if we have pre-loaded the data server-side
    if(window.__INITIAL_STATE__) {
      var init_state = JSON.parse(window.__INITIAL_STATE__);
      
      if('faq' in init_state.data) {
        if(init_state.data.faq.articles) {
          this.articles.data = init_state.data.faq.articles;
        }
        
        if(init_state.data.faq.categories) {
          this.categories.data = init_state.data.faq.categories;
          this.categories.filtered = init_state.data.faq.categories;
        }
        
        if(init_state.data.faq.current.categoryURL) {
          this.current.categoryURL = init_state.data.faq.current.categoryURL;
          this.filterCategories();
        }
      }
    }
    
    // If not, start loading the data client-side
    if(this.articles.data.length === 0) {
      this.loadArticles();
    }
    if(this.categories.data.length === 0) {
      this.loadCategories();
    }
    
  },
  mounted() {
    
    // Scroll to open article
    if(this.articleSlug && this.articles.data.length > 0){
      this.scrollToArticle(0);
    }
    
  },
  methods: {
    async loadArticles() {
      // Start loading
      this.articles.loading = true;
      
      // Request data from API
      await this.$axios.get(this.apiURL+"faq?grouped=true"). then((response) => {
        this.articles.data = response.data.faq;
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading the FAQ. Please reload page to try again.");
      });
      
      // Finish loading
      this.articles.loading = false;
      
      // Scroll to open article
      this.scrollToArticle(500);
      
    },
    async loadCategories() {
      // Start loading
      this.categories.loading = true;
      
      // Request data from API
      await this.$axios.get(this.apiURL+"faq/categories"). then((response) => {
        this.categories.data = response.data.categories;
        
        if(this.categorySlug) {
          this.current.categoryURL = '/faq/'+this.categorySlug;
        }
        this.filterCategories();
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading the FAQ. Please reload page to try again.");
      });
      
      // Finish loading
      this.categories.loading = false;
      
    },
    filterCategories() {
      if(this.categories.data) {
        var filteredCats = [];
        
        for( var i = 0; i < this.categories.data.length; i++ ){
          if(this.currentCategory.name === 'All Categories' || this.currentCategory.name === this.categories.data[i].name) {
            filteredCats.push(this.categories.data[i]);
          } 
        }
        
        this.categories.filtered = filteredCats;
      }
    },
    scrollToArticle(delay = 0) {
      var vm = this;
      
      setTimeout(function(){
        var borderOffset = window.innerWidth >= 768 ? (window.innerWidth * 0.02) + 10 : 10;
        
        vm.$scrollTo('article.open', 500, {offset: -borderOffset, cancelable: false});
      }, delay);
      
    }
  },
  watch:{
    // eslint-disable-next-line
    $route (to, from){
      if(to.name === 'Faq' || to.name === 'FaqCategory') {
        this.current.categoryURL = to.path;
        this.selectorOpen = false;
        this.filterCategories();
      }
      
      if(to.name === 'FaqArticle') {
        if(this.current.categoryURL !== '/faq') {
          this.current.categoryURL = '/faq/' + this.categorySlug;
          this.filterCategories();
        }
        
        this.scrollToArticle(600);
      }
    }
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
};
</script>